<template>
  <div class="regular-header">

  <nav v-scroll="handleScroll" class="navbar">
  <div class="container">

    <router-link class="router-link" to="#">
    <img v-scroll="handleScrollPartTwo" id="logo" src="@/assets/Folded_Paper_logo.svg">
    <div class="logo-dot"></div>
    </router-link>

  <div  v-scroll="handleScrollPartThree" class="menu-trigger" @mouseup="menuOpen=!menuOpen">
    <a class="hover-button" v-scroll-to="{el:'#form-aanmelden', offset:-200}"> Claim je sessie </a>
    
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" id="path">
            <path d="M22,22 L2,22 C2,11 11,2 22,2 C33,2 42,11 42,22" ></path>
        </symbol>
    </svg>
  </div>
  </div>

  </nav>

  <img class="oval-bg-landing" src="../assets/Folded_Paper_oval-bg-landing.png">
  <img class="oval-bg-landing-2" src="../assets/Folded_Paper_oval2-bg-landing.png">

   <headerGrid>
      <div class="font-size-custom-max-48"><h1 id="font-calc-durf">Jij durft!</h1></div>
      <br>
      <p>Gaaf om te zien dat jij aan de slag wil met je merkidentiteit! Wij willen bouwen aan merken die een bijdrage willen leveren aan een betere wereld en <span class="yellow"> maatschappelijk verantwoord ondernemen</span>. Benieuwd hoe wij jou kickstarten tijdens een <span class="yellow"> merkidentiteitsessie</span>? <br>Scroll dan gauw door!
      </p>
      <a class="button-down" v-scroll-to="{el:'#usp-section-kick', offset:-200}"><img src="../assets/Folded_Paper_asset_arrow_down.png"></a>
   </headerGrid>

   <div id="usp-section-kick" class="usp-section-landing">
    <h3>Wij kickstarten dit met... </h3>
    <ul>
      <li> <p> Je <span class="red"> te gekke </span> mission statement </p> </li>
      <li> <p> Een <span class="red"> duidelijke </span> omschrijving van je Why, How & What </p> </li>
      <li> <p> Het in beeld brengen van je <span class="red"> sleutelkwaliteiten </span> </p> </li>
      <li> <p> Een <span class="red"> kick-ass </span> brandstory </p> </li>
    </ul>
    <a v-scroll-to="{el:'#form-aanmelden', offset:-200}"> Claim je sessie </a>
    <!-- <img class="img-mob" src="../assets/Folded_Paper_landinsgpage_usp-bg-mobile.png"> -->
   </div>


  <oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="odd-even-grid even">
      <div class="text-box">
        <div class="content padding-right">
          <h3>Investering</h3>
          <p>Zie deze sessie als een investering in je merk. Binnen een paar uur verzorgen wij een identiteitsessie en na afloop krijg je dit zwart op wit op papier. Normaal kost dit <span class="red-line-trough"> 895,-</span> maar bieden deze nu aan voor <span class="yellow"> 395,-</span>. Wij bieden maximaal 10 sessies aan tot 30 september. Dus claim snel je sessie!</p>
        </div>
      </div>
      <div class="img-box">
        <img class="float-right" src="../assets/FP_landingspage_tarief.png">
      </div>
    </div>
  </oddEvenGrid>

  <oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="odd-even-grid odd">
      <div class="img-box">
        <img src="../assets/FP_landingspage_bij_ons.png">
      </div>
      <div class="text-box">
        <div class="content padding-left">
          <h3>Bij ons of bij jou?</h3>
          <p>Stiekem komen wij het liefst bij jullie langs. Zo kunnen wij ons beter verdiepen in de organisatie en cultuur.</p>
        </div>
      </div>
    </div>
  </oddEvenGrid>

  <ContactFormLandingsPage id="form-aanmelden" />
  <footerComponent></footerComponent>

</div>

</template>

<script>
import headerGrid from '@/components/generalLayout/headerGrid.vue';
import oddEvenGrid from '@/components/generalLayout/oddEvenGrid.vue';
import ContactFormLandingsPage from '@/components/generalLayout/ContactFormLandingsPage.vue';
import footerComponent from '@/components/specificLayout/footerComponent.vue';

export default {
  name: 'cultuur',

  components:{
    headerGrid,
    oddEvenGrid,
    ContactFormLandingsPage,
    footerComponent
  },

methods: {

  handleScroll: function (evt, el,) {
    if (window.scrollY > 100 && screen.width > 640) {
        el.setAttribute(
          'style',
          'background-color: white; box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05), 0 10px 7px 0 rgba(0, 0, 0, 0.02); transition: 0.3s all; height: 100px; z-index:999;'
        )
      } else { 
        el.setAttribute(
          'style',
          'background-color: transparant; height: 140px'
      )} 
    },

    handleScrollPartTwo: function (evt, el) {
        
      if (window.scrollY > 100 && screen.width > 640) {
        el.setAttribute(
          'style',
          'margin-top: 22px !important; transition: 0.3s all;'
        )
      } else { 
        el.setAttribute(
           'style',
          'margin-top: 64px; transition: 0.3s all;'
      )} 
    },
    
    handleScrollPartThree: function (evt, el) {

        if (window.scrollY > 100 && screen.width > 640) {
        el.setAttribute(
          'style',
          'top: 38px; transition: 0.3s all;'
        )
      } else { 
        el.setAttribute(
          'style',
          'top: 64px; transition: 0.3s all;'
      )} 
    },
  },
}

</script>

<style lang="scss">
.conformation {
  border-radius: 10px;
  top: 16px;
  position: relative;
}

.footer-bottom {
  background:white;
}

.v-scroll-reveal {
  position: relative;
  z-index: 9;
}

a {
  font-family: $font-stack-copy;
  font-weight: 800;
}

p{
  opacity: 1 !important;
}

.hover-button {
  @include transition-regular-fast;
  &:hover {
    background-color: $yellow;
    @include transition-regular-fast;
  }
}


.img-mob{
  display: none;
}

.error {
  margin-top:-10px;
}

.red {
  color: #E94B5A;
  font-weight: 900;
}

.red-line-trough {
  color: #E94B5A;
  text-decoration-line: line-through;
  font-weight: 900;
}

.yellow {
  color: #FDC75F;
  font-weight: 900;
  font-size: 20px;
}

.oval-bg-landing {
  position: fixed;
  left:0;
  top:130px;
  z-index: 1;
  max-height: 500px;
}
.oval-bg-landing-2 {
  position: fixed;
  right:0;
  top:300px;
  z-index: 1;
  max-height: 500px;
}

.navbar .menu-trigger {
  top: 80px;
}

.menu-trigger {
  a {
    border: 2px solid rgba(0,0,0,1);
    padding: 16px 48px;
    border-radius: 100px;
    color:  rgba(0,0,0,1);
    font-weight: 900;
  }
}
.button-down {
  img {
    border: 1px dashed black;
    border-radius: 30px;
    padding: 12px;
    max-width: 50px;
    max-height: 50px;
    width: 100%;
    height: 100%;
  }
}

.usp-section-landing {
  position: relative;
  width: 100%;
  margin: 0 auto;
  display: block;
  padding: 64px;
  clear: both;
  z-index: 99;

  background-image: url(../assets/FP_landingspage_banner.gif);
  background-repeat: no-repeat;
  background-size: 100%;
  max-width: 700px;
  margin: 0 auto;
  min-height: 320px;

    ul {
      list-style: none;
      padding: 0;

      li {
        position: relative;
        padding-left: 32px;

        &:before {
          content: '';
          position: absolute;
          background-image: url(../assets/checkmark.png);
          background-repeat: no-repeat;
          height: 21px;
          width: 21px;
          left:0;
        }
      }
    }

    a {
      position: absolute;
      bottom: -23px;
      left: 50%;
      transform: translateX(-50%);
      background: $black;
      color: $white;
      padding: 16px 48px;
      border-radius: 100px;
    }
}

@media screen and (max-width: 640px) {
  .oval-bg-landing, .oval-bg-landing-2 {
    display: none;
  }
  .menu-trigger a {
    position: relative;
    top:8px;
  }
  .usp-section-landing {
    width: 90%;
    max-width: 380px;
    height: 590px;
    background-size: contain;
    background-position: center;
  }
  .usp-section-landing h3 {
     max-width: 220px;
     margin: 0 auto;
    padding-top: 40px;
  }
  .usp-section-landing ul{
    max-width: 220px;
    margin: 0 auto;
  }
  .menu-trigger a {
    position: relative;
    right: -12px;
    padding: 16px 24px;
  }
  .padding-left {
    padding-left: 0 !important;
  }
  .form {
    margin-top: 60px !important;
    background-image: none !important;
    background-color: rgba(253,199,95,0.15);
    border: 1px dashed black;
    border-radius: 10px;
    padding-bottom: 0px !important;
  }
  .usp-section-landing {
    background-image: none;
    padding: 0;
  }
  .img-mob{
    display: block;
    width: 90%;
    margin: 0 auto;
    margin-top: 40px;
  }
  .form-group input {
    width: 90% !important;
  }
  .even {
    margin-top: 32px !important;
  }
  .form-group .activelabelName {
    left:10% !important;
  } 
  .form-group .activelabelNumber {
    left:10% !important;
  }
   .form-group .activelabelEmail {
    left:10% !important;
  }
  .usp-section-landing {
    background-image: url(../assets/Folded_Paper_samen_sterker-mobile.gif);
    margin-bottom: 70px;
  }
}

@media screen and (max-width: 379px) {
  .usp-section-landing a {
    padding: 16px 32px;
  }
}
</style>
